var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"textarea",staticClass:"c-textarea",attrs:{"maxlength":_vm.maxlength,"name":_vm.name,"placeholder":_vm.placeholder,"rows":_vm.rows,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"focusout":_vm.focusout,"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }